import ContextMenuTemplate from './templates/ContextMenu.html';
const { url, routes, OverDrive, text, html } = window;

export default class ContextMenu extends Backbone.View {
    template = ContextMenuTemplate;

    constructor() {
        super(...arguments);

        this.rid = Math.random().toString(36).substring(7);

        this.listenTo(this.model, 'change:isInHistory', () => this.render());

        this.render();
    }

    events() {
        const events = {
            'click .js-historyAction': '_handleClickHistory',
            'keydown .ContextMenu-drop': '_keepFocus',
            'keydown .js-context-button': 'toggle',
            'click .js-context-button': 'toggle',
            'keyup .js-context-drop': '_handleKeyUpContainer',
            'keydown .menu-option': 'handleSpaceKeydown',
        };

        return events;
    }

    get viewModel() {
        let seriesSearchUrl = '';
        if (!this.model.isMagazine) {
            if (this.model.get('detailedSeries')) {
                seriesSearchUrl = url(routes.searchByType, {
                    type: 'seriesId',
                    query: this.model.get('detailedSeries').seriesId,
                    sortBy: 'readingOrder',
                });
            } else if (this.model.get('series')) {
                seriesSearchUrl = url(routes.searchByType, {
                    type: 'series',
                    query: this.model.get('series'),
                    sortBy: 'newlyadded',
                });
            }
        }

        let hasMediaDoFormat = false;
        this.model.get('formats').forEach((format) => {
            if (format.id === 'ebook-media-do') {
                hasMediaDoFormat = true;
            }
        });

        let maturityLevel = this.model.attributes.ratings.maturityLevel.id;

        const relatedTitlesPageUrl = `${window.url(
            window.routes.mediaRelatedId,
            {
                id: this.model.get('id'),
            }
        )}${maturityLevel ? `?maturityLevel=${maturityLevel}` : ''}`;

        return {
            isOwned: this.model.get('isOwned'),
            relatedTitlesPageUrl,
            id: this.model.id,
            rid: this.rid,
            title: this.model.get('title'),
            typeId: this.model.get('type').id,
            sampleHref: this.model.get('sample').href || '',
            sampleText: this._getSampleText(),
            alignment: 'bottom',
            historyActionLabel: this._getHistoryActionLabel(),
            historyActionText: this._getHistoryActionText(),
            historyEnabled:
                OverDrive.showHistoryFeature &&
                !this.model.get('isPreReleaseTitle'),
            gaHistoryAction: this.model.get('isInHistory')
                ? 'history-remove'
                : 'history-add',
            seriesSearchUrl,
            hasMediaDoFormat,
        };
    }

    render() {
        this.$el.empty().append(this.template(this.viewModel));
        return this;
    }

    isSelectEvent = (e) =>
        (e.key === 'Enter' || e.key === ' ' || e.type === 'click') &&
        (e.preventDefault() || true);

    close() {
        window.Foundation.libs.dropdown.close(
            this.$el.find('.js-context-drop')
        );
        this.$el.find('.ContextMenu-button').focus();
    }

    handleSpaceKeydown(e) {
        const target = $(e.target);
        if (e.key === ' ') {
            e.preventDefault();
            if (!target.is('a')) {
                target.click();
            } else {
                target[0].click();
            }
        }
    }

    toggle(e) {
        if (this.isSelectEvent(e)) {
            e.stopImmediatePropagation();
            if (window.notificationDrawer && window.notificationDrawer.isOpen) {
                window.notificationDrawer.close();
            }
            window.Foundation.libs.dropdown.close($('#drop-collections'));
            window.Foundation.libs.dropdown.toggle(
                this.$el.find('.js-context-button')
            );

            setTimeout(() => {
                if (this.$el.find('.js-context-button').hasClass('open')) {
                    this.$el.find('.menu-option').first().focus();
                }
            }, 200);
        }
    }

    _keepFocus(e) {
        const activeEle = $(document.activeElement);
        const firstFocusable = this.$el.find('.menu-option').first();
        const lastFocusable = this.$el.find('.menu-option').last();

        if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey)) {
            const nextEle = activeEle.is(lastFocusable)
                ? firstFocusable
                : activeEle.parent().next().find('.menu-option');
            nextEle.focus();
        } else if (e.key === 'ArrowUp' || (e.key === 'Tab' && e.shiftKey)) {
            const prevEle = activeEle.is(firstFocusable)
                ? lastFocusable
                : activeEle.parent().prev().find('.menu-option');
            prevEle.focus();
        } else {
            return;
        }
        e.preventDefault();
    }

    _handleKeyUpContainer(e) {
        if (e.key === 'Escape') {
            this.close();
        }
    }

    _handleClickHistory() {
        this.model.trigger('title:action', {
            action: 'history',
            model: this.model,
        });
    }

    _handleKeyHistory(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.stopImmediatePropagation();
            this.model.trigger('title:action', {
                action: 'history',
                model: this.model,
            });
        }
    }

    _getSampleText() {
        const type = this.model.get('type').id;

        if (type === 'audiobook' || type === 'music') {
            return text('sampleListen');
        } else if (type === 'video') {
            return text('sampleWatch');
        }

        return text('sampleRead');
    }

    _getHistoryActionLabel() {
        const title = this.model.get('title');
        if (this.model.get('isInHistory')) {
            return html('readingHistory.removeTitle', { title });
        } else {
            return html('readingHistory.addTitle', { title });
        }
    }

    _getHistoryActionText() {
        if (this.model.get('isInHistory')) {
            return html('readingHistory.remove');
        } else {
            return html('readingHistory.add');
        }
    }
}
